module.exports = __webpack_public_path__ + "static/media/BG_64.548fe5ca.png";